import React, { useEffect, useState } from 'react';
import { Loader, Table } from '../../../../UiKit';
import { EmptyState } from '../../../commons';
import { InvalidSearchImg } from '../../../../images/images';
import { getDrops } from './utils';
import { orderModel } from '../../../../api';

export const EmergencyDrops = ({ orderId = null }) => {
  const [emergencyDrops, setEmergencyDrops] = useState(null);
  const [error, setError] = useState(null);

  const visits = emergencyDrops?.drops?.length ? emergencyDrops.drops : null;

  useEffect(() => {
    const getEmergencyDropsData = () => {
      const queryParams = {};
      queryParams['order_id'] = orderId;
      orderModel
        .getEmergencyDrops(queryParams)
        .then((response) => {
          if (!response || (response && response.isError === true))
            return setError(response);
          setEmergencyDrops(response);
        })
        .catch((error) => {
          setError(error);
        });
    };

    getEmergencyDropsData();
  }, [orderId]);

  if (!emergencyDrops && !error) {
    return <Loader />;
  }
  if (error) {
    return (
      <EmptyState
        img={InvalidSearchImg}
        heading={error?.message || 'No data available!'}
        isPop={true}
      />
    );
  }

  return (
    <div className='tw-mx-6 tw-mb-6' data-dd-privacy='mask'>
      {visits && <Table tableData={getDrops(visits)} />}

      {!visits && (
        <EmptyState
          img={InvalidSearchImg}
          heading='No drops have been made yet'
          isPop={true}
        />
      )}
    </div>
  );
};
